import React from 'react'

const MaximizeIcon = props => {
  const height = props.height || 20
  const width = props.width || 20
  const color = props.color || '#202020'
  return (
    <div style={{ display: 'flex', padding: '24px', height: '100px', width: '100px', background: '#eef0f8', alignItems: 'center', borderRadius: '50%' }}>
      <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44">
        <g stroke={color} fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3.667" y="3.667" width="36.667" height="36.667" rx="3" />
          <path d="M34.834 9.167 25.85 18.15M18.15 25.85l-8.983 8.984M27.133 9.167h7.7v7.7M16.867 34.833h-7.7v-7.7" />
        </g>
      </svg>
    </div>
  )
}

export default MaximizeIcon
